import mitt from 'mitt';

const notificationBus = mitt();
export default notificationBus;
